import Core from 'core/js/components/cities-select/list-layout/index.js'
import template from './index.pug'
import Home from 'js/components/home/index.js'

export default Vue.extend({
  extends: Core,
  name: 'city-select-list-custom-gc',
  template: template(),

  components: {
    Home
  },

  methods: {
    login() {
      this.$emit('login')
    },
  }
})
